import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { Controller } from 'react-hook-form'

import AntDropdown from 'components/AntDropdown'
import FormItem from 'components/Form/Item'
import FormattedMessage from 'components/FormattedMessage'

const EventCity = (props) => {
  const {
    cities,
  } = props

  const intl = useIntl()

  return (
    <FormItem label={<FormattedMessage id="contactRequestForm.cityId" />}>
      <Controller
        name="cityId"
        defaultValue={cities[0]?.id}
        render={({
          field: { onChange, onBlur, value, name, ref },
        }) => (
          <AntDropdown
            className="contact-request-form__room-type"
            placeholder={intl.formatMessage({ id: 'contactRequestForm.pleaseSelect' })}
            ref={ref}
            segments={[
              {
                name: 'cityId',
                options: cities.map(({ id, displayName }) => ({ id, text: displayName })),
                currentValue: value,
              },
            ]}
            useNativeSelectOnMobile={true}
            onChange={(values) => onChange(values.cityId.toString())}
            onBlur={onBlur}
          />
        )}
      />
    </FormItem>
  )
}

EventCity.propTypes = {
  cities: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default EventCity
